import React from 'react';
import { useNavigate } from 'react-router-dom';
import Breadcrumb, { BreadcrumbGroup } from '@amzn/meridian/breadcrumb';

export interface BreadcrumbItem {
  /** The display label (pre-translated string) */
  label: string;
  /** The navigation path. If omitted, the item is rendered as non-clickable text. */
  path?: string;
}

export interface BreadcrumbsProps {
  /** Ordered list of breadcrumb items from root to current page */
  items: BreadcrumbItem[];
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  const navigate = useNavigate();

  if (items.length === 0) return null;

  return (
    <BreadcrumbGroup>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <Breadcrumb
            key={`${item.label}-${index}`}
            onClick={!isLast && item.path ? () => { navigate(item.path!); } : undefined}
          >
            {item.label}
          </Breadcrumb>
        );
      })}
    </BreadcrumbGroup>
  );
};
